import request from 'sb-request'
import { reducers } from 'redux/core'

import productsQuery from './products.graphql'


const reset = () => reducers.view.zodiacSignPage.reset()

const fetchProducts = (gender, zodiacSign) => {
  reducers.view.zodiacSignPage.setFetchStatus(true)

  return request.post('graphql?name=products', {
    body: {
      query: productsQuery,
      variables: {
        input: {
          gender,
          zodiacs: [ zodiacSign.toUpperCase() ],
        },
      },
    },
  })
    .then(({ products }) => {
      reducers.view.zodiacSignPage.setProducts(products)
    })
}

export default {
  fetchProducts,
  reset,
}
